import { ReactNode } from "react";
import applicationInsights from "../../services/application-insights/application-insights";
import { TrackEventNames } from "./track-event-name-enum";

type WrapperProps = {
	children: ReactNode;
	eventName: TrackEventNames;
	properties?: { [key: string]: string | object };
	type: "button" | "link" | "toggle_button";
	isDisabled?: boolean;
};

/**
 * @param eventName: The name of the click event used for tracking
 * @param type: Element type
 *
 */

const CustomEventWrapper = ({ children, eventName, properties, type, isDisabled }: WrapperProps) => {
	const handleClick = () => {
		if (isDisabled) {
			return;
		}

		const props = {
			...properties,
			type: type,
		};
		applicationInsights.trackEvent(eventName, props);
	};

	return (
		<div onClick={handleClick} style={{ display: "inline" }}>
			{children}
		</div>
	);
};

export default CustomEventWrapper;
